import { usePromiseTracker } from "react-promise-tracker";

// Every page already wraps its axios calls in trackPromise(), but nothing
// consumed that tracked state until now — this renders a thin progress bar
// at the top of the content pane whenever any tracked request is in flight.
const LoadingIndicator = () => {
    const { promiseInProgress } = usePromiseTracker();

    if (!promiseInProgress) {
        return null;
    }

    return (
        <div className="sticky top-0 left-0 right-0 z-50 h-1 overflow-hidden bg-brand/20">
            <div className="h-full w-1/3 bg-brand animate-loading-bar" />
        </div>
    );
};

export default LoadingIndicator;
